module.exports = __webpack_public_path__ + "static/media/style-icon.38501b87.svg";